<template>
    <Card class="p-4 p-md-5 m-0 shadow rounded-lg">
        <slot></slot>
    </Card>
</template>



<script>
    export default {
        name: 'Wrapper',
    };
</script>



<style lang="scss" scoped>
    ::v-deep {
        p {
            font-size: 16px;
        }
    }
</style>
